import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.CompanyTypeEnumSortEnum>
) {
  const { pagination, sort } = params;

  const {
    companyTypeEnumList: { items: data, total },
  } = await sdk.getListCompanyTypeEnum(filterSortPage({ sort, pagination }));

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { companyTypeEnum: data } = await sdk.getOneCompanyTypeEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { companyTypeEnumMany: data } = await sdk.getManyCompanyTypeEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const companyTypeEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
